type TreeNode = {
    key: string;
    parent: string | number;
    reason: string;
    notice: string;
    reason_1: string;
    notice_1: string;
    system: boolean | string;
    root: boolean;
    card5WayID: number;
    level: number;
    children: TreeNode[];
    continue: boolean;
    remove: boolean;
    delete: boolean;
    category?: string;
};

export function wrapTreeWithCategory(
    tree: TreeNode[],
    categoryName = "5Почему"
): TreeNode[] {
    if (!tree.length) return [];

    // Клонируем root старого дерева
    const rootNode = structuredClone(tree[0]);

    // Новый category root
    const categoryRoot: TreeNode = {
        key: "category_0",
        parent: 0,
        reason: "",
        notice: "",
        reason_1: "",
        notice_1: "",
        system: "",
        root: false,
        card5WayID: rootNode.card5WayID,
        level: 1,
        category: categoryName,
        continue: false,
        remove: true,
        delete: false,
        children: [],
    };

    // Переносим reason/notice -> reason_1/notice_1
    rootNode.reason_1 = rootNode.reason;
    rootNode.notice_1 = rootNode.notice;

    rootNode.reason = "";
    rootNode.notice = "";

    // Обновляем root node
    rootNode.parent = categoryRoot.key;
    rootNode.level = 2;
    rootNode.category = categoryName;
    rootNode.continue = true;

    // Снимаем root флаг
    rootNode.root = false;

    // Рекурсивное обновление детей
    const updateNodes = (nodes: TreeNode[], level: number) => {
        nodes.forEach((node) => {
            node.level = level;
            node.category = categoryName;

            // Снимаем root у всех
            node.root = false;

            if (node.children?.length) {
                updateNodes(node.children, level + 1);
            }
        });
    };

    updateNodes([rootNode], 2);

    categoryRoot.children = [rootNode];

    // Flatten
    const result: TreeNode[] = [];

    const flatten = (node: TreeNode) => {
        result.push(node);

        node.children?.forEach(flatten);
    };

    flatten(categoryRoot);

    return result;
}